import React from "react";
import "./SeaFreight.css";
import { Link } from "react-router-dom";

import { FaShip ,FaPlane, FaClock, FaHandshake, FaMapMarkedAlt } from "react-icons/fa";

function SeaFreight() {
  return (
    <div className="sea-wrapper">

      {/* HERO SECTION */}
      <section className="sea-hero">
        <div className="container hero-container">

          <div className="sea-hero-icon-title">
            <FaShip size={50} className="sea-icon-green" />
            <h1 className="hero-title">Efficient and Economical Sea Freight Solutions</h1>
          </div>

          <p className="hero-subtext">
            D2D Express offers reliable sea freight services for businesses looking
            for cost-effective solutions without compromising on safety or reliability.
          </p>

          <ul className="hero-points">
            <li>📦 <strong>Cost-Effective:</strong> Competitive rates for large shipments.</li>
            <li>🌍 <strong>Global Reach:</strong> Access to major ports worldwide.</li>
            <li>🚢 <strong>Sustainability:</strong> Environmentally friendly for heavy cargo.</li>
          </ul>

          <Link to="/" className="sea-back-btn">Back to Home</Link>
        </div>
      </section>

      {/* FEATURES GRID */}
      <section className="features-section">
        <div className="container features-grid">

          <div className="feature-card">
            <h3>FCL & LCL Expertise</h3>
            <p>
              We handle Full Container Load (FCL) and Less than Container Load (LCL)
              with optimized consolidation and route planning.
            </p>
          </div>

          <div className="feature-card">
            <h3>Timely Customs Clearance</h3>
            <p>
              Experienced clearance teams ensure minimal dwell time at ports.
            </p>
          </div>

          <div className="feature-card">
            <h3>Reliable Port Handling</h3>
            <p>
              Professional port-side coordination ensures smooth loading and unloading.
            </p>
          </div>

          <div className="feature-card">
            <h3>Door-to-Door Delivery</h3>
            <p>
              Seamless movement from ship to last-mile, ensuring complete peace of mind.
            </p>
          </div>

        </div>
      </section>

    </div>
  );
}

export default SeaFreight;
